/**
 * Der Zustand eines Geschaeftstags.
 *
 * Punkt, Wort und - bei Abweichung - ein Zeichen. Nie Farbe allein: rot
 * und gruen sind fuer einen nennenswerten Teil der Menschen dieselbe
 * Farbe.
 */
export function Ampel({ zustand, mitText = true }: { zustand: string | null; mitText?: boolean }) {
  const k = zustand === 'GREEN' ? 'gruen' : zustand === 'AMBER' ? 'gelb'
    : zustand === 'RED' ? 'rot' : 'gelb'
  const text = zustand === 'GREEN' ? 'Abgeglichen'
    : zustand === 'AMBER' ? 'Mit Befund'
    : zustand === 'RED' ? 'Abweichung'
    : 'Noch nicht geprüft'
  const zeichen = zustand === 'RED' ? '!' : zustand === 'AMBER' ? '·' : ''
  return (
    <Tipp text={text}>
      <span className={`ampel ${k}`}>
        <span className="punkt" aria-hidden="true" />
        {mitText && <span>{text}{zeichen && ` ${zeichen}`}</span>}
      </span>
    </Tipp>
  )
}
import { Tipp } from './Hinweis'
